export default "__VITE_ASSET__D7h$eC1L__"